export default ['$scope', '$location', 'Transfer', 'EFTRequests',
  function ($scope, $location, Transfer, EFTRequests) {
    $scope.filters = {};

    $scope.$on('$routeUpdate', () => loadTransfers());
    $scope.$on('refreshTransfersList', () => loadTransfers());

    $scope.setTransferForDialog = transfer => {
      return $scope.transferId = transfer.id;
    };

    const add_flags_to_statuses = () => {
      $scope.transfers.metadata.statuses.push({ value: 100, name: "Trade Required" });
      return $scope.transfers.metadata.statuses.push({ value: 101, name: "Waiting For Cash Settlement" });
    };

    const modify_search_filters = filters => {
      const f = Object.assign(filters);
      // Rails ALERT, Rails does not handle semicolons correctly parse with stringify and they need to be manually filtered out
      if (f.clientSearch) {
        f.clientSearch = f.clientSearch.replace(/;/g, '');
      }
      if (f.status) {
        if (typeof (f.status) !== 'object') {
          f.status = [f.status];
        }
        const modified_statuses = f.status.filter(value => {
          if ((value === 100) || (value === '100')) {
            f.tradeRequired = true;
            return false;
          }
          if ((value === 101) || (value === '101')) {
            f.waitingForCashSettlement = true;
            return false;
          }
          return true;
        });
        f.status = modified_statuses;
      }
      return f;
    };

    var loadTransfers = () => {
      $scope.filters.category = $location.search().category;
      $scope.filters.dateRequested = $location.search().dateRequested;
      $scope.filters.clientSearch = $location.search().clientSearch ? $location.search().clientSearch : '';
      $scope.filters.frequency = $location.search().frequency;
      $scope.filters.status = $location.search().status;
      $scope.filters.tradeRequired = $location.search().tradeRequired;
      $scope.filters.waitingForCashSettlement = $location.search().waitingForCashSettlement;
      $scope.filters.startDate = $location.search().startDate;
      $scope.filters.amount = {
        from: $location.search().amountFrom,
        to: $location.search().amountTo
      };
      if ($location.search().orderBy) { $scope.orderBy = $location.search().orderBy; }
      if ($location.search().reverse) { $scope.reverse = $location.search().reverse; }
      $scope.page = $location.search().page ? $location.search().page : 1;
      $scope.limit = $location.search().limit ? $location.search().limit : 10;
      $scope.search = $location.search().search ? $location.search().search : '';

      return Transfer.get({
        filters: modify_search_filters($scope.filters),
        page: $scope.page,
        limit: $scope.limit,
        orderBy: $scope.orderBy,
        reverse: $scope.reverse,
        search: $scope.search
      }).$promise.then(transfers => {
        $scope.transfers = transfers;
        return add_flags_to_statuses();
      });
    };

    if ($location.url() === $location.path()) {
      $location.search({ status: [0, 3, 7, 9, 10, 11] });
    } else {
      loadTransfers();
    }
    return $scope;
  }
];
